/**
 * Return the current origin such as
 * https://app.our-domain-here.com
 * https://localhost:8080
 */
export function getLocationOrigin(): string {
  return window.location.origin;
}
